<template>
    <div>

    </div>
</template>

<script>
    /* global gapi */

    import vanilla from '../../services/vanilla'
    import {
        LOADING_STARTED,
        LOADING_COMPLETED_SUCCESS,
        LOADING_COMPLETED_FAILURE,
        GET_GOOGLE_PLATFORM_CLIENT_ID_URL,
        SET_GOOGLE_PLATFORM_STATE,
        INIT_GOOGLE_PLATFORM_AUTH_2,
    } from '../../services/constants'

    export default {
        name: 'google-platform',
        props: {},
        data() {
            return {
                nativeWindow: null,
                nativeDocument: null,
                googlePlatformScriptTag: null,
                clientIdMetaTag: null,
            }
        },
        computed: {
            clientIdUrl() {
                return this.$store.getters[GET_GOOGLE_PLATFORM_CLIENT_ID_URL]
            }
        },
        methods: {
            init() {
                this.$store.commit(SET_GOOGLE_PLATFORM_STATE, {
                    state: LOADING_STARTED,
                    data: null,
                    error: null,
                })
                this.googlePlatformScriptTag = this.nativeDocument.createElement('script');
                this.googlePlatformScriptTag.type = 'text/javascript';
                this.googlePlatformScriptTag.async = true;
                this.googlePlatformScriptTag.defer = true;
                this.googlePlatformScriptTag.src = 'https://apis.google.com/js/platform.js';
                this.googlePlatformScriptTag.addEventListener('load', this.onGooglePlatformScriptTagLoad)
                const firstScriptTagOnDocument = this.nativeDocument.getElementsByTagName('script')[0];
                firstScriptTagOnDocument.parentNode.insertBefore(this.googlePlatformScriptTag, firstScriptTagOnDocument);

                this.clientIdMetaTag = this.nativeDocument.createElement('meta');
                this.clientIdMetaTag.setAttribute('name', 'google-signin-client_id');
                this.clientIdMetaTag.setAttribute('content', this.clientIdUrl);
                const firstMetaTagOnDocument = this.nativeDocument.getElementsByTagName('meta')[0];
                firstMetaTagOnDocument.parentNode.insertBefore(this.clientIdMetaTag, firstMetaTagOnDocument);


            },
            onGooglePlatformScriptTagLoad(evt) {
                if (this.googlePlatformScriptTag.getAttribute('gapi_processed')) {
                    this.$store.commit(SET_GOOGLE_PLATFORM_STATE, {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: gapi,
                        error: null,
                    })
                    this.$store.dispatch(INIT_GOOGLE_PLATFORM_AUTH_2)
                } else {
                    this.$store.commit(SET_GOOGLE_PLATFORM_STATE, {
                        state: LOADING_COMPLETED_FAILURE,
                        data: null,
                        error: null,
                    })
                }

                this.googlePlatformScriptTag.removeEventListener('load', this.onGooglePlatformScriptTagLoad)
            }
        },
        created() {
            this.nativeWindow = vanilla.getNativeWindowObject()
            this.nativeDocument = vanilla.getNativeDocumentObject()
            this.init()
        }

    }
</script>

<style scoped lang="scss">

</style>
